/**
 * Shared Tailwind class fragments for the PhenoTips `DataTable` family.
 * Kept in one place so `data-table-*.tsx` files stay small and diffs stay clear.
 */
export const dataTableTheadClass = 'bg-muted/40 border-b border-border';
export const dataTableHeaderRowTextClass =
  'text-left text-[10.5px] font-semibold uppercase tracking-[0.1em] text-muted-foreground';
export const dataTableRowClass =
  'border-b border-border last:border-0 hover:bg-brand-soft/40 transition-colors';
export const dataTableCellDataClass =
  'px-4 py-3 text-[13px] text-foreground first:pl-5 last:pr-5';
export const dataTableCellOffsetClass = 'text-xs tabular-nums sm:text-[13px]';
